// extracted by mini-css-extract-plugin
export default {"tooltip":"PS-z","arrow":"QS-z"};